module.exports = __webpack_public_path__ + "static/media/battle-axe.47a5ba50.svg";